import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Tooltip } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../service/AuthContext';
import DialogProfile from './DialogProfile';
import DialogAnnouncement from './DialogAnnouncement';
import { useGlobalContext } from '../context/GlobalContext';
import { useHomeworkContext } from '../context/HomeworkContext';
import logo from '../images/thumbnail_logo512D.png';

const drawerWidth = 280;

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppBarAdmin = ({ open, toggleDrawer }) => {
  const { userInfo, setUserInfo, logout, currentUser } = useAuth();
  const { setSelectedUser, setTotalStars } = useGlobalContext();
  const { setOpenEditHw, setSelectedHw, setRating, setGroup } = useHomeworkContext();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNotiBoardOpen, setIsNotiBoardOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setUserInfo(null);
    setSelectedUser(null);
    setTotalStars(0);
    setOpenEditHw(false);
    setSelectedHw(null);
    setRating(0);
    setGroup('students');
    await logout();
    navigate('/login/admin');
  };

  const openProfile = () => setIsProfileOpen(true);
  const closeProfile = () => setIsProfileOpen(false);

  const openNotificationBoard = () => setIsNotiBoardOpen(true);
  const closeNotificationBoard = () => setIsNotiBoardOpen(false);

  return (
    <StyledAppBar sx={{background: 'linear-gradient(180deg, #000000 30%, #283747 99%)'}} position="absolute" open={open}>
      <Toolbar sx={{ pr: '24px' }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{ marginRight: '36px', ...(open && { display: 'none' }) }}
        >
          <MenuIcon />
        </IconButton>
        <img src={logo} alt="logo" style={{ width: '40px', height: '40px', marginRight: '16px' }} />
        <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
         Welcome {currentUser.displayName}!
        </Typography>
        <Tooltip title="Announcement">
          <IconButton color="inherit" onClick={openNotificationBoard}>
              <NotificationsIcon />
          </IconButton>
        </Tooltip>
        <DialogAnnouncement open={isNotiBoardOpen} handleClose={closeNotificationBoard} isAdmin={true}/>
        <Tooltip title="Profile">
          <IconButton color="inherit" onClick={openProfile}>
            <ManageAccountsIcon />
          </IconButton>
        </Tooltip>
        <DialogProfile open={isProfileOpen} handleClose={closeProfile} selectedUser={userInfo} setSelectedUser={setUserInfo}/>
        <Tooltip title="Logout">
          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </StyledAppBar>
  );
};

export default AppBarAdmin;